<template>
  <TransitionGroup name="fade-up" appear :tag="tag" v-bind="$attrs" v-on="$listeners">
    <slot />
  </TransitionGroup>
</template>

<script>
export default {
  name: 'FadeInUpGroup',
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  }
}
</script>
